import { Injectable } from '@angular/core';
import { NotificationSlugEnum } from '@app/generated/graphql';

@Injectable({ providedIn: 'root' })
export class NotificationIconConfig {
  // configuration around the icon to be displayed for a notification
  private _iconMap: Record<NotificationSlugEnum, string> = {
    [NotificationSlugEnum.Example]: '/assets/icons/general/warning.svg',
  };

  public getIcon(notificationSlug: NotificationSlugEnum): string {
    return this._iconMap[notificationSlug];
  }
}
